/* ==========================================================================
   NADUVA THEME — theme.js
   ========================================================================== */
(function () {
  "use strict";

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) =>
    (window.Shopify && Shopify.currency ? "" : "") +
    new Intl.NumberFormat(document.documentElement.lang || "en", {
      style: "currency",
      currency: window.NV_CURRENCY || "USD",
    }).format(cents / 100);

  /* ---------- Generic drawer open/close ---------- */
  function openDrawer(drawer, overlay) {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    if (overlay) overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawers() {
    $$(".nv-cart-drawer,.nv-mobile-menu").forEach((d) => {
      d.classList.remove("is-open");
      d.setAttribute("aria-hidden", "true");
    });
    const ov = $(".nv-drawer-overlay");
    if (ov) ov.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    const burger = $("[data-nv-burger]");
    const menu = $(".nv-mobile-menu");
    if (burger && menu) burger.addEventListener("click", () => openDrawer(menu, $(".nv-drawer-overlay")));
    $$("[data-nv-mobile-toggle]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const sub = btn.parentElement.nextElementSibling;
        if (sub) sub.classList.toggle("is-open");
      });
    });
  }

  /* ---------- Close handlers ---------- */
  function initClose() {
    document.addEventListener("click", (e) => {
      if (e.target.closest("[data-nv-close]")) closeDrawers();
      if (e.target.classList.contains("nv-drawer-overlay")) closeDrawers();
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeDrawers();
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    $$(".nv-acc__btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!expanded));
        const panel = btn.nextElementSibling;
        if (panel) panel.classList.toggle("is-open", !expanded);
      });
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    const gallery = $("[data-nv-gallery]");
    if (!gallery) return;
    const main = $("[data-nv-gallery-main] img", gallery);
    $$("[data-nv-thumb]", gallery).forEach((thumb) => {
      thumb.addEventListener("click", () => {
        const src = thumb.getAttribute("data-full");
        if (main && src) {
          main.src = src;
          main.srcset = "";
        }
        $$("[data-nv-thumb]", gallery).forEach((t) => t.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  }

  /* ---------- Variant picker ---------- */
  function initVariantPicker() {
    const form = $("[data-nv-product-form]");
    if (!form) return;
    let variants = [];
    try {
      variants = JSON.parse($("[data-nv-variant-json]", form).textContent);
    } catch (e) {
      return;
    }
    const idInput = $("[data-nv-variant-id]", form);
    const priceEl = $("[data-nv-price]");
    const atc = $("[data-nv-atc]", form);
    const galleryMain = $("[data-nv-gallery-main] img");

    function selectedOptions() {
      return $$("[data-nv-option-index]", form).map((group) => {
        const checked = $("input:checked", group);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.find((v) =>
        v.options.every((o, i) => o === opts[i])
      );
    }

    function updateAvailabilityLabels(opts) {
      // mark sold-out option values based on current partial selection
      $$("[data-nv-option-index]", form).forEach((group, gi) => {
        $$("input", group).forEach((input) => {
          const trial = opts.slice();
          trial[gi] = input.value;
          const match = variants.filter((v) =>
            v.options.every((o, i) => trial[i] == null || o === trial[i])
          );
          const avail = match.some((v) => v.available);
          const wrap = input.closest(".nv-tile-opt,.nv-swatch");
          if (wrap) wrap.classList.toggle("is-soldout", !avail);
        });
      });
    }

    function update() {
      const opts = selectedOptions();
      updateAvailabilityLabels(opts);
      // reflect chosen value label
      $$("[data-nv-option-index]", form).forEach((group) => {
        const checked = $("input:checked", group);
        const out = $("[data-nv-option-value]", group);
        if (out && checked) out.textContent = checked.value;
      });
      const variant = findVariant(opts);
      if (!variant) {
        if (atc) {
          atc.disabled = true;
          atc.textContent = "Unavailable";
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        let html = "";
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          html =
            '<span class="nv-price__compare">' + money(variant.compare_at_price) + "</span>" +
            '<span class="nv-price__sale">' + money(variant.price) + "</span>";
        } else {
          html = money(variant.price);
        }
        priceEl.innerHTML = html;
      }
      if (variant.featured_image && galleryMain) {
        galleryMain.src = variant.featured_image.src;
        galleryMain.srcset = "";
      }
      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? "Add to bag" : "Sold out";
      }
    }

    form.addEventListener("change", (e) => {
      if (e.target.matches("[data-nv-option-input]")) update();
    });
    update();
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest("[data-nv-qty]");
      if (!btn) return;
      const wrap = btn.closest(".nv-qty");
      const input = $("input", wrap);
      let val = parseInt(input.value, 10) || 1;
      val += btn.getAttribute("data-nv-qty") === "plus" ? 1 : -1;
      input.value = Math.max(1, val);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  /* ---------- AJAX add to cart ---------- */
  function initAjaxCart() {
    document.addEventListener("submit", async (e) => {
      const form = e.target.closest("[data-nv-product-form]");
      if (!form) return;
      e.preventDefault();
      const atc = $("[data-nv-atc]", form);
      const original = atc ? atc.textContent : "";
      if (atc) {
        atc.disabled = true;
        atc.textContent = "Adding…";
      }
      try {
        const fd = new FormData(form);
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          body: fd,
        });
        if (!res.ok) throw new Error("add failed");
        await refreshCart();
        openDrawer($(".nv-cart-drawer"), $(".nv-drawer-overlay"));
      } catch (err) {
        window.location.href = "/cart";
      } finally {
        if (atc) {
          atc.disabled = false;
          atc.textContent = original;
        }
      }
    });

    // quick-add buttons on cards
    document.addEventListener("click", async (e) => {
      const qa = e.target.closest("[data-nv-quickadd]");
      if (!qa) return;
      e.preventDefault();
      const id = qa.getAttribute("data-nv-quickadd");
      qa.disabled = true;
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: Number(id), quantity: 1 }),
        });
        await refreshCart();
        openDrawer($(".nv-cart-drawer"), $(".nv-drawer-overlay"));
      } catch (err) {
        /* noop */
      } finally {
        qa.disabled = false;
      }
    });

    // remove / change qty inside drawer
    document.addEventListener("click", async (e) => {
      const rm = e.target.closest("[data-nv-cart-remove]");
      if (!rm) return;
      e.preventDefault();
      await changeLine(rm.getAttribute("data-nv-cart-remove"), 0);
    });
  }

  async function changeLine(key, quantity) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    });
    await refreshCart();
  }

  async function refreshCart() {
    const res = await fetch("/?section_id=cart-drawer");
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, "text/html");
    const fresh = doc.querySelector("[data-nv-cart-drawer-content]");
    const target = $("[data-nv-cart-drawer-content]");
    if (fresh && target) target.innerHTML = fresh.innerHTML;
    // update header count
    try {
      const cart = await (await fetch("/cart.js")).json();
      $$("[data-nv-cart-count]").forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? "" : "none";
      });
    } catch (e) {}
  }

  function initCartOpen() {
    $$("[data-nv-cart-open]").forEach((btn) =>
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        openDrawer($(".nv-cart-drawer"), $(".nv-drawer-overlay"));
      })
    );
  }

  /* ---------- Hero slideshow ---------- */
  function initHero() {
    $$("[data-hero]").forEach((hero) => {
      const track = $("[data-hero-slides]", hero);
      const slides = $$(".hero__slide", hero);
      if (!track || slides.length < 2) return;
      const dotsWrap = $("[data-hero-dots]", hero);
      let i = 0, timer;
      if (dotsWrap && !dotsWrap.children.length) {
        slides.forEach((_, k) => {
          const b = document.createElement("button");
          b.type = "button";
          b.className = "hero__dot" + (k === 0 ? " is-active" : "");
          b.setAttribute("aria-label", "Go to slide " + (k + 1));
          b.addEventListener("click", () => { set(k); restart(); });
          dotsWrap.appendChild(b);
        });
      }
      const dots = dotsWrap ? Array.from(dotsWrap.children) : [];
      function set(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = "translateX(-" + i * 100 + "%)";
        dots.forEach((d, k) => d.classList.toggle("is-active", k === i));
      }
      function restart() { clearInterval(timer); timer = setInterval(() => set(i + 1), 6000); }
      const nx = $("[data-hero-next]", hero), pv = $("[data-hero-prev]", hero);
      if (nx) nx.addEventListener("click", () => { set(i + 1); restart(); });
      if (pv) pv.addEventListener("click", () => { set(i - 1); restart(); });
      set(0); restart();
    });
  }

  /* ---------- Product rails (prev/next scroll) ---------- */
  function initRails() {
    $$("[data-rail-prev],[data-rail-next]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const rail = btn.closest(".rail") || btn.parentElement;
        const track = $("[data-rail-track]", rail);
        if (!track) return;
        const dir = btn.hasAttribute("data-rail-next") ? 1 : -1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: "smooth" });
      });
    });
  }

  /* ---------- Swatch colour resolver ----------
     Resolves named colours to a fill when no native Shopify swatch or
     variant image is set. Order: curated commerce map -> native CSS named
     colour (148 of them) -> leave the neutral default. Native swatches and
     variant images (handled in Liquid) already cover unlimited colours. */
  var NV_COLORS = {
    // neutrals
    "white":"#ffffff","off white":"#f7f5f0","ivory":"#fffff0","cream":"#f5efe0","eggshell":"#f0ead6",
    "beige":"#e8dcc4","sand":"#e3d5b8","oatmeal":"#e0d6c3","nude":"#e8c9b0","stone":"#d6cfc4",
    "taupe":"#b8a99a","greige":"#bfb6a8","khaki":"#c3b091","tan":"#d2b48c","camel":"#c19a6b",
    "chai":"#b08d57","caramel":"#af6e4d","coffee":"#6f4e37","espresso":"#4b3621","mocha":"#3c2f2f",
    "brown":"#7b4a2e","chocolate":"#4a2c2a","walnut":"#5c4033","chestnut":"#954535","cognac":"#9a463d",
    "rust":"#b7410e","terracotta":"#c66b3d","clay":"#b66a50","sienna":"#a0522d","bronze":"#cd7f32",
    // greys + black
    "black":"#000000","jet black":"#0a0a0a","onyx":"#0f0f0f","ink":"#101418","charcoal":"#36393b",
    "graphite":"#3a3a3a","gunmetal":"#2a3439","slate":"#5a6470","slate grey":"#5a6470","slate gray":"#5a6470",
    "grey":"#808080","gray":"#808080","heather grey":"#b6b6b6","heather gray":"#b6b6b6","ash":"#b2beb5",
    "light grey":"#d3d3d3","light gray":"#d3d3d3","dark grey":"#4b5563","dark gray":"#4b5563",
    "silver":"#c0c0c0","platinum":"#e5e4e2","pewter":"#8a8d8f","smoke":"#9a9a9a","fog":"#c8ccce",
    // blues
    "blue":"#185fa5","navy":"#1b2a4a","navy blue":"#1b2a4a","midnight":"#191970","midnight blue":"#191970",
    "royal blue":"#1d4ed8","cobalt":"#0047ab","sapphire":"#0f52ba","denim":"#3b5b8c","indigo":"#4b0082",
    "sky blue":"#87ceeb","light blue":"#add8e6","baby blue":"#b9d9eb","powder blue":"#b0e0e6","ice blue":"#d6ecef",
    "steel blue":"#4682b4","slate blue":"#6a5acd","periwinkle":"#9aa3e0","cornflower":"#6495ed",
    "turquoise":"#30d5c8","aquamarine":"#7fffd4","seafoam":"#9fe2bf","ocean":"#1f6f8b","azure":"#1e90ff",
    "aqua":"#00b0c0","cyan":"#00bcd4","petrol":"#1c5b63","teal":"#008080","dark teal":"#0d5c5c",
    // greens
    "green":"#2e7d32","forest green":"#14532d","forest":"#14532d","dark green":"#14532d","bottle green":"#0a3d2e",
    "emerald":"#0f8a5f","kelly green":"#3aa64a","grass green":"#4caf50","fern":"#5b8a3a","hunter green":"#355e3b",
    "olive":"#6b7d3a","olive green":"#6b7d3a","army green":"#4b5320","military green":"#4b5320","moss":"#8a9a5b",
    "sage":"#9caf88","sage green":"#9caf88","mint":"#9be7c4","mint green":"#9be7c4","pistachio":"#93c572",
    "lime":"#9acd32","lime green":"#9acd32","chartreuse":"#b0c33a","avocado":"#7a8b3a",
    // yellows + oranges
    "yellow":"#ffd400","lemon":"#fff44f","canary":"#ffef00","gold":"#d4af37","golden":"#d4af37",
    "mustard":"#d4a017","amber":"#ffbf00","honey":"#e6a817","ochre":"#cc7722","marigold":"#eaa221",
    "orange":"#f57c00","burnt orange":"#cc5500","tangerine":"#f28500","apricot":"#fbceb1","peach":"#ffcba4",
    "coral":"#ff6f61","salmon":"#fa8072","papaya":"#ff9e6b",
    // reds + pinks
    "red":"#d32f2f","crimson":"#b00020","scarlet":"#c41e3a","cherry":"#a4133c","ruby":"#9b111e",
    "brick":"#9c3a2e","brick red":"#9c3a2e","tomato":"#e44d3a","fire red":"#cc2a1f",
    "burgundy":"#6b1f2e","wine":"#5e1f2a","maroon":"#5a1a26","oxblood":"#4a121b","merlot":"#5a2231",
    "pink":"#f48fb1","hot pink":"#e6178c","fuchsia":"#d6336c","magenta":"#c2185b","cerise":"#d62a6b",
    "rose":"#f4a6b4","dusty rose":"#c08497","blush":"#f3c6c6","mauve":"#b784a7","old rose":"#c08081",
    "rosegold":"#b76e79","rose gold":"#b76e79","raspberry":"#b3284f","watermelon":"#fc6c85",
    // purples
    "purple":"#7c3aed","violet":"#7f00ff","plum":"#6a2c5a","grape":"#5b2a86","aubergine":"#4b2e44",
    "eggplant":"#4b2e44","lavender":"#c4b5fd","lilac":"#c8a2c8","orchid":"#b06ab3","amethyst":"#9966cc",
    "wisteria":"#c9a0dc",
    // specials
    "multicolor":"linear-gradient(135deg,#ff0040,#ff8a00 22%,#ffe600 40%,#00d26a 58%,#0091ff 76%,#a259ff)",
    "multi":"linear-gradient(135deg,#ff0040,#ff8a00 22%,#ffe600 40%,#00d26a 58%,#0091ff 76%,#a259ff)",
    "multicolour":"linear-gradient(135deg,#ff0040,#ff8a00 22%,#ffe600 40%,#00d26a 58%,#0091ff 76%,#a259ff)",
    "rainbow":"linear-gradient(135deg,#ff0040,#ff8a00 22%,#ffe600 40%,#00d26a 58%,#0091ff 76%,#a259ff)",
    "assorted":"linear-gradient(135deg,#bbb,#eee 50%,#bbb)","clear":"#eef2f4","transparent":"#eef2f4",
    "natural":"#e3d5b8","wood":"#9b6f43","leopard":"#b8860b","camo":"#5b6650","floral":"#e7a6b8"
  };
  function initSwatchColors() {
    var nodes = $$("[data-nv-color]");
    if (!nodes.length) return;
    var probe = document.createElement("span");
    nodes.forEach(function (el) {
      var name = (el.getAttribute("data-nv-color") || "").trim().toLowerCase();
      if (!name) return;
      var hex = NV_COLORS[name] || NV_COLORS[name.replace(/\s+/g, "")];
      if (!hex) {
        var candidate = name.replace(/\s+/g, "");
        probe.style.color = "";
        probe.style.color = candidate;
        if (probe.style.color !== "") hex = candidate;
      }
      if (hex) el.style.background = hex;
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initMobileMenu();
    initClose();
    initAccordions();
    initGallery();
    initVariantPicker();
    initQty();
    initAjaxCart();
    initCartOpen();
    initHero();
    initRails();
    initSwatchColors();
  });
})();
